import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { ReactPortal } from '~src/new/shared/ui/ReactPortal/ReactPortal'
import { CloseButton } from '~src/new/shared/ui/CloseButton/CloseButton'
import cls from './sidebar-modal.module.scss'
import { ModalSheet } from '@/shared/ui/ModalSheet'
import { useWidth } from '@/src/app/providers/WidthProvider'

export const SidebarModal = props => {
  const { isOpen: isOpenProp, children, onClose, props: wrapperProps } = props
  const [isOpen, setIsOpen] = useState(isOpenProp)
  const { isMobile } = useWidth()

  const handleClose = () => {
    setIsOpen(false)
    setTimeout(() => {
      onClose?.()
    }, 250)
  }

  useEffect(() => {
    setIsOpen(isOpenProp)
  }, [isOpenProp])

  useEffect(() => {
    if (!isOpen) return undefined
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = previousOverflow
    }
  }, [isOpen])

  useEffect(() => {
    if (!isOpen) return undefined
    const onKeyDown = e => {
      if (e.key === 'Escape') {
        onClose?.()
      }
    }
    window.addEventListener('keydown', onKeyDown)
    return () => {
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [isOpen, onClose])

  if (!isOpenProp) return null

  if (isMobile) {
    if (!children) return null
    return (
      <ModalSheet theme="black" isOpen={isOpenProp} onClose={handleClose}>
        <div className={cls.rootMobile}>
          {children ? (
            <div className={cls.contentContainerMobile}>
              <div className={cls.body}>{children}</div>
            </div>
          ) : null}
        </div>
      </ModalSheet>
    )
  }

  return (
    <ReactPortal>
      <div className={classNames(cls.root, isOpen && cls.open)}>
        <div className={cls.backdrop} onClick={handleClose} />
        {children ? (
          <div className={cls.panel}>
            <div className={cls.header}>
              <div className={cls.title}>{wrapperProps.title}</div>
              <CloseButton variant="OUTLINE" className={cls.close} onClick={handleClose} />
            </div>
            <div className={cls.body}>{children}</div>
          </div>
        ) : null}
      </div>
    </ReactPortal>
  )
}

SidebarModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func,
}

SidebarModal.defaultProps = {
  title: '',
  children: null,
  onClose: undefined,
}
